import { UserKind } from './user-kind';
import { UserModel } from './user-model';

export class UserDetailedModel extends UserModel {
  kind: UserKind|null;
}
